import {Axios} from "@/shared/api/axiosInstance.ts";
import {PaginationRes} from "@/shared/types/index.ts";
import {Favorite} from "@/features/dashboard/types/favorite.ts";

const listFavoritesByType = (businessID: string, userID: string, favoriteType: string): Promise<PaginationRes> =>
    Axios.get<any, PaginationRes>(`/businesses/${businessID}/collaborators/${userID}/favorites?type=${favoriteType}`);

const getFavoriteTabs = (businessID: string, userID: string): Promise<PaginationRes> =>
  Axios.get<any, PaginationRes>(`/businesses/${businessID}/collaborators/${userID}/favorites?type=tabs`)

const updateFavorite = (businessID: string, userID: string, itemID: string, data: Favorite): Promise<void> =>
  Axios.patch<any, void>(`/businesses/${businessID}/collaborators/${userID}/favorites/${itemID}`, data);

export {
    listFavoritesByType,
    getFavoriteTabs,
    updateFavorite,
}
